import Button from 'components/Button/Button'
import { Input } from 'components/Input'
import Table from 'components/Table'
import React from 'react'
import { RelationshipsProps } from './Relationships.props'
import {
  RelationshipFooter,
  RelationshipFooterContent,
  RelationshipsContainer,
  RelationshipTitle,
} from './Relationships.styled'
import RelationshipsItem from './RelationshipsItem'
import Select from 'components/Select'
import { object, string } from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'
import { useAppDispatch, useAppState } from 'store'
import { userActions } from 'store/slices/users/users.slice'

const RELATIONSHIPS_LIST_HEADER: string[] = [
  'Name',
  'Email',
  'Profile',
  'Relation',
]

type RelationForm = {
  email: string
  relation: string
}

const schema = object().shape({
  email: string().required().email(),
  relation: string().required(),
})

const RELATION_OPTION = [
  { label: 'Parent', value: 'parent' },
  { label: 'Child', value: 'child' },
]

const Relationships: React.FC<RelationshipsProps> = () => {
  const dispatch = useAppDispatch()
  const { loading } = useAppState(state => state.user)
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = useForm<RelationForm>({
    resolver: yupResolver(schema),
  })

  const onSubmit = handleSubmit(async data => {
    const fields = {
      family: {
        family_email: data.email.toLowerCase(),
        relation: data.relation,
      },
    }
    await dispatch(userActions.setUserFamily(fields))
  })
  return (
    <RelationshipsContainer>
      <Table header={RELATIONSHIPS_LIST_HEADER} styles={{ width: '100%' }}>
        <RelationshipsItem />
      </Table>

      <RelationshipFooter>
        <RelationshipTitle>Add Relationship</RelationshipTitle>
        <RelationshipFooterContent>
          <div style={{ width: '100%', marginRight: 15 }}>
            <Input
              label={'Email'}
              required
              error={errors.email && errors.email.message}
              {...register('email')}
            />
          </div>
          <div style={{ width: '100%', marginLeft: 15 }}>
            <Controller
              name="relation"
              control={control}
              render={({ field }) => (
                <Select
                  label="Relation"
                  required
                  options={RELATION_OPTION}
                  value={RELATION_OPTION.find(
                    option => option.value === field.value
                  )}
                  error={errors.relation && errors.relation.message}
                  onChange={(event: any) => {
                    field.onChange(event.value)
                  }}
                  onBlur={field.onBlur}
                />
              )}
            />
          </div>
        </RelationshipFooterContent>
        <Button
          text="Save"
          size="small"
          variant="primary"
          onClick={onSubmit}
          loading={loading === 'loading' ? true : false}
          disabled={loading === 'loading' ? true : false}
        />
      </RelationshipFooter>
    </RelationshipsContainer>
  )
}

export default Relationships
